// Apartment Images - User provided
export const apartmentImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/f4x6wmlc_1.png",
    alt: "Balkon sa pogledom"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/ajg6va53_2.png",
    alt: "Dnevni boravak"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/sptix2ys_3.png",
    alt: "Spavaća soba"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/ofqj0zbu_4.png",
    alt: "Spavaća soba sa kaminom"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/oock3ucc_6.png",
    alt: "Spavaća soba detalj"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/rczbm24y_5.png",
    alt: "Kava uz prozor"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/5vvojve7_7.png",
    alt: "Dnevni boravak sa pogledom"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/hxjsfrxr_8.png",
    alt: "Spavaća soba sa ormarom"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/vsvodw48_9.png",
    alt: "Moderno kupatilo"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/6bz83tb2_11.png",
    alt: "Kamin i radni prostor"
  }
];

// Hero images
export const heroImages = [
  "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/f4x6wmlc_1.png",
  "https://customer-assets.emergentagent.com/job_6259e2cb-c3fd-4e11-ac8c-113022f54b90/artifacts/ajg6va53_2.png"
];

// Attractions data
export const attractions = [
  {
    id: 1,
    name: "Baščaršija",
    description: "Srce Sarajeva - historijski bazar s autentičnim zanatskim radnjama, tradicionalnim kafama i Sebiljem. Prošetajte kaldrmanim ulicama, probajte ćevape i bosansku kafu, te uživajte u jedinstvenoj atmosferi Starog grada.",
    distance: "15 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/7jdgxv4j_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/pwpvotrq_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/heer8f6q_image.png"
    ]
  },
  {
    id: 2,
    name: "Raskrižje vjera i kultura",
    description: "Sarajevo je stoljećima poznato kao mjesto susreta religija, gdje se na malom prostoru susreću crkve, džamije i sinagoge. U njegovoj povijesti isprepliću se katolička, islamska, pravoslavna i židovska tradicija, stvarajući jedinstven kulturni i duhovni mozaik. Upravo ta raznolikost daje gradu poseban identitet i simboliku suživota različitih vjera i naroda.",
    distance: "2 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/8gcepaw9_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/w5lt4utf_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/coth54u3_image.png"
    ]
  },
  {
    id: 3,
    name: "Vijećnica",
    description: "Simbolička građevina Sarajeva u pseudo-maurskom stilu. Obnovljena nakon rata, danas je kulturni centar i domaćin brojnih izložbi i koncerata. Noću je posebno impresivna zahvaljujući rasvjeti.",
    distance: "12 min hoda",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/chdjinng_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/hdgtnbmq_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/3qdygrtz_image.png"
    ]
  },
  {
    id: 4,
    name: "Trebević",
    description: "Planina koja nadvisuje Sarajevo s olimpijskom bobsled stazom. Žičarom se za samo 10 minuta popnete na vrh s predivnim pogledom na grad. Idealno za planinarenje, zip-line i uživanje u prirodi.",
    distance: "20 min hoda do žičare",
    images: [
      "https://images.unsplash.com/photo-1694551351580-e3d17e363478",
      "https://images.pexels.com/photos/18714730/pexels-photo-18714730.jpeg",
      "https://images.unsplash.com/photo-1746588592126-20dd61ecb11d"
    ]
  },
  {
    id: 5,
    name: "Između znamenitosti i prirodnih ljepota",
    description: "Sarajevo nudi savršen spoj urbane arhitekture i netaknute prirode. Od impozantne Vijećnice i historijske Latinske ćuprije, do kristalno čistih izvora i spektakularnih vodopada - sve je nadohvat ruke. Istražite bogatstvo koje ovaj grad i njegova okolica nude.",
    distance: "U krugu od 30 min",
    images: [
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/bs3fa5o1_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/3wzqy5uz_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/6wycvng6_image.png",
      "https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/ge07whxk_image.png"
    ]
  }
];

// FAQ data
export const faqData = [
  {
    question: "Koje je vrijeme prijave i odjave?",
    answer: "Prijava (check-in) je moguća od 15:00 do 23:00, a odjava (check-out) od 07:00 do 11:00. Molimo vas da nas unaprijed obavijestite o vremenu vašeg dolaska."
  },
  {
    question: "Da li mogu dovesti kućnog ljubimca?",
    answer: "Nažalost, kućni ljubimci nisu dozvoljeni u apartmanu."
  },
  {
    question: "Da li apartman ima parking?",
    answer: "Da, apartman nudi besplatno privatno parkirno mjesto."
  },
  {
    question: "Da li je dozvoljeno pušenje?",
    answer: "Pušenje nije dozvoljeno unutar apartmana."
  },
  {
    question: "Koliki je kapacitet apartmana?",
    answer: "Apartman može primiti do 2 odrasle osobe + dijete (0-3 godine). Krevetić za bebe dostupan je na zahtjev besplatno."
  },
  {
    question: "Da li su dozvoljene zabave?",
    answer: "Zabave i eventi nisu dozvoljeni u apartmanu."
  },
  {
    question: "Koja je veličina apartmana?",
    answer: "Apartman ima 35 m² prostora s jednom spavaćom sobom."
  }
];

// Amenities data
export const amenities = [
  { icon: "Wifi", label: "Besplatan WiFi" },
  { icon: "Thermometer", label: "Klima uređaj" },
  { icon: "Flame", label: "Kamin" },
  { icon: "Car", label: "Besplatan parking" },
  { icon: "Mountain", label: "Pogled na planine" },
  { icon: "Bath", label: "Tuš kabina" },
  { icon: "Tv", label: "TV" },
  { icon: "Utensils", label: "Opremljena kuhinja" },
  { icon: "Wind", label: "Sauna" }
];

// Contact info
export const contactInfo = {
  phone: "+387 61 055 637",
  email: "vesna.lazic91@yahoo.com",
  whatsapp: "+38761055637",
  instagram: "https://www.instagram.com/peakview508_apartman?igsh=MWtsdzM0azRqb2Rxag==",
  address: "Olimpijska 1, Apartman 508, 5. sprat, 71423 Jahorina, BiH"
};

// Apartment info
export const apartmentInfo = {
  name: "PeakView 508",
  subtitle: "Cozy Alpine Apartment",
  tagline: "Udoban apartman s pogledom na Jahorini",
  description: "🏔 PeakView 508 Cozy Alpine Apartment – Vaš planinski kutak na Jahorini Dobro došli u PeakView 508 Cozy Alpine Apartment, mali planinski kutak stvoren za odmor, toplinu i uživanje u čarima Jahorine tokom cijele godine. Smješten u aparthotelu Vučko, prekoputa ski lifta, apartman vam omogućava da dan započnete na stazi za svega nekoliko minuta. Nakon aktivnog dana na snijegu ili svježem planinskom zraku, dočekat će vas ugodan i pažljivo uređen prostor u kojem se možete istinski opustiti. Sa balkona se pruža predivan pogled na planinu — savršeno mjesto za jutarnju kafu ili mirne večeri uz planinsku tišinu. Apartman je svijetao, komforan i osmišljen tako da se osjećate kao kod kuće. Gostima je na raspolaganju besplatan parking i Wi-Fi, a u sklopu aparthotela nalaze se restorani i kafići gdje možete uživati u domaćoj i internacionalnoj kuhinji bez potrebe da napuštate kompleks. Za porodice s djecom tu je i dječija igraonica, što boravak čini još jednostavnijim i ugodnijim. Za potpuni odmor, gostima je dostupna i wellness & spa zona (uz nadoplatu), sa saunama, parnim kupatilom, whirlpoolom i prostorom za relaksaciju — idealno mjesto za opuštanje nakon dana provedenog na planini. Bilo da dolazite zbog zimskih radosti ili ljetnog mira, PeakView 508 je mjesto gdje planina postaje doživljaj, a odmor istinsko zadovoljstvo. Radujemo se vašem dolasku i želimo vam toplu dobrodošlicu na Jahorinu 🤍",
  capacity: "2 odrasle osobe + dijete",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Olimpijska%201%2C%20Jahorina%2C%20BiH"
};